module.exports = __webpack_public_path__ + "static/media/daniel-huss.c9368ce9.jpg";